import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GET_STATISTICS_ACCOUNT_EXCEL_API_URL, GET_STATISTICS_ACTIVE_KTV_API_URL, GET_STATISTICS_ACTUALIZATION_HOUSE_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_EXCEL_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_RAPORT_EXCEL_API_URL, GET_STATISTICS_CABLE_ACCOUNT_API_URL, GET_STATISTICS_CABLE_CANTON_API_URL, GET_STATISTICS_CABLE_EXCEL_API_URL, GET_STATISTICS_INFRASTRUCTURE_ACCOUNT_API_URL, GET_STATISTICS_PILLAR_API_URL } from '../OpticApiConfig';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { loadingCanton } from '../LoadingData/LoadingDataTerritory';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CustomSnackbar from '../Components/CustomSnackbar';
import {Button} from '@mui/material';


//#region STYLE
const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};
//#endregion 

const StatisticPillar = (user) => {
  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  
  const [selectedCanton, setSelectedCanton] = useState('');
  const [resultCantonOptic, setCantonOptic] = useState([]);
  const [filteredResult, setFilteredResult] = useState([]);
  const [error, setError] = useState(null);  
  const token = localStorage.getItem('token');
  const [canton, setCanton] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [areaFilter, setAreaFilter] = useState('');

  const [onlyGorSvet, setOnlyGorSvet] = useState(false);
  const [onlyDtek, setOnlyDtek] = useState(false);
  const [onlyUkrTelecom, setOnlyUkrTelecom] = useState(false);
  const [onlyPoltavaEnergo, setOnlyPoltavaEnergo] = useState(false);
  const [onlyUnknown, setOnlyUnknown] = useState(false);


  useEffect(() => {
    loadingCanton(setCanton); 
  }, []); 

  // Загрузка данных
const handleButtonClick = async () => {
  if (!selectedCanton) {
    setError('Пожалуйста, выберите округ.');
    return;
  }

  try {
    setError(null); 
    const response = await axios.get(GET_STATISTICS_PILLAR_API_URL, {
      headers: { Authorization: `Bearer ${token}` },
      params: { canton: selectedCanton }
    });

    setCantonOptic(response.data); // ✅ правильное имя
    setFilteredResult(response.data);
    setIsVisible(true);
  } catch (error) {
    console.error(error);
    setError('Произошла ошибка при загрузке данных.');
  }
};

  // Фильтр по area
  const handleAreaFilterChange = (e) => {
    const value = e.target.value;
    setAreaFilter(value);

    if (!value) {
      setFilteredResult(resultCantonOptic);
      return;
    }

    const filtered = resultCantonOptic.filter(item => 
      item.area.toString().includes(value)
    );
    setFilteredResult(filtered);
  };

   const copyToClipboard = (text) => {
        const textCoord = document.createElement("textarea");
        textCoord.value = text;
        document.body.appendChild(textCoord);
        textCoord.select();
        textCoord.focus(); 
        try {
          const successful = document.execCommand("copy");
          if (successful) {
            showSnackbar('Скопировано: ' + text, 'snackbarOk');
          } else {
            showSnackbar('Не удалось скопировать в буфер обмена', 'snackbarError');
          }
        } catch (err) {
          showSnackbar('Не удалось скопировать в буфер обмена', 'snackbarError');
        }
        document.body.removeChild(textCoord);
      };
     

      // Следим за фильтрами и пересчитываем список
useEffect(() => {
  let filtered = [...resultCantonOptic];

  // Фильтр по area
  if (areaFilter) {
    filtered = filtered.filter(item =>
      item.area?.toString().includes(areaFilter)
    );
  }

  if (onlyGorSvet) {
    filtered = filtered.filter(item => item.ownerPillarId === 1);
  }
  if (onlyDtek) {
    filtered = filtered.filter(item => item.ownerPillarId === 3);
  }
  if (onlyUkrTelecom) {
    filtered = filtered.filter(item => item.ownerPillarId === 4);
  }
  if (onlyPoltavaEnergo) {
    filtered = filtered.filter(item => item.ownerPillarId === 6);
  }
  if (onlyUnknown) {
    filtered = filtered.filter(item => item.ownerPillarId === 5);
  }

  setFilteredResult(filtered);
}, [resultCantonOptic, areaFilter, onlyGorSvet, onlyDtek,onlyUkrTelecom, onlyPoltavaEnergo, onlyUnknown]);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>  
        <hr className="horizontalLineDrawer" style={{ marginTop: "5px" }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <label className='textTitleDrawer' style={{ fontSize: "20px", marginLeft: "10px", textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>
            Опоры
          </label>
          <Select
            className="selectSearchDrawer"
            options={canton.map(option => ({ value: option, label: option }))}
            isSearchable={true}
            styles={customStyles}
            placeholder="Округ"
            onChange={(selectedOption) => setSelectedCanton(selectedOption.value)} 
          />
          <button 
            className='buttonAutoTopology' 
            style={{ marginTop: "0px", padding: "10px" }}
            onClick={handleButtonClick} 
          >
            Загрузить
          </button>
        </div>
        <hr className="horizontalLineDrawer" style={{ marginTop: "0px" }} />
      </div>
   
      {isVisible && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          
          {/* Фильтр по area */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
            <label style={{ marginLeft: '10px',color: "#c5c5c5", textShadow: '2px 2px 4px #242424'}}>Всего: <span style={{color: "orange"}}>{filteredResult.length}.</span></label>
           
            <input 
              type="number" 
              value={areaFilter} 
              onChange={handleAreaFilterChange} 
              placeholder="поиск по веткам" 
              className='textInputPoiskModal'
              style={{width: '150px',fontSize: '14px'}}
            />

              <label style={{ marginLeft: '15px', color: '#ccc', fontSize: '14px' }}>
                <input
                    type="checkbox"
                    checked={onlyGorSvet}
                     onChange={(e) => {
                        setOnlyGorSvet(e.target.checked);
                        if (e.target.checked) {
                            setOnlyDtek(false);
                            setOnlyPoltavaEnergo(false);
                            setOnlyUkrTelecom(false);
                            setOnlyUnknown(false);
                        }
                    }}
                    style={{ marginRight: '5px', verticalAlign: 'middle' }}
                 />
                 Горсвет
               </label>

               <label style={{ marginLeft: '15px', color: '#ccc', fontSize: '14px' }}>
                <input
                    type="checkbox"
                    checked={onlyDtek}
                     onChange={(e) => {
                        setOnlyDtek(e.target.checked);
                        if (e.target.checked) {
                            setOnlyGorSvet(false);
                            setOnlyPoltavaEnergo(false);
                            setOnlyUkrTelecom(false);
                            setOnlyUnknown(false);
                        }
                    }}
                    
                    style={{ marginRight: '5px', verticalAlign: 'middle' }}
                 />
                 ДТЭК
               </label>

                <label style={{ marginLeft: '15px', color: '#ccc', fontSize: '14px' }}>
                <input
                    type="checkbox"
                    checked={onlyUkrTelecom}
                    onChange={(e) => {
                        setOnlyUkrTelecom(e.target.checked);
                        if (e.target.checked) {
                            setOnlyDtek(false);
                            setOnlyPoltavaEnergo(false);
                            setOnlyGorSvet(false);
                            setOnlyUnknown(false);
                        }
                    }}
                    style={{ marginRight: '5px', verticalAlign: 'middle' }}
                 />
                 Укртелеком
               </label>

               <label style={{ marginLeft: '15px', color: '#ccc', fontSize: '14px' }}>
                <input
                    type="checkbox"
                    checked={onlyPoltavaEnergo}
                     onChange={(e) => {
                        setOnlyPoltavaEnergo(e.target.checked);
                        if (e.target.checked) {
                            setOnlyDtek(false);
                            setOnlyUkrTelecom(false);
                            setOnlyGorSvet(false);
                            setOnlyUnknown(false);
                        }
                    }}
                    style={{ marginRight: '5px', verticalAlign: 'middle' }}
                 />
                 Полтаваобленерго
               </label>

                 <label style={{ marginLeft: '15px', color: '#ccc', fontSize: '14px' }}>
                <input
                    type="checkbox"
                    checked={onlyUnknown}
                     onChange={(e) => {
                        setOnlyUnknown(e.target.checked);
                        if (e.target.checked) {
                            setOnlyDtek(false);
                            setOnlyUkrTelecom(false);
                            setOnlyGorSvet(false);
                            setOnlyPoltavaEnergo(false);
                        }
                    }}
                    style={{ marginRight: '5px', verticalAlign: 'middle' }}
                 />
                 Неизвестно
               </label>
           
          </div>

         <div className="scroll-container" 
            style={{
              flex: 1,
              maxWidth: "100%",
              maxHeight: "70vh",  // ✅ вместо height
              overflowY: "auto",
              paddingBottom: "10px",
              display: "block" ,
              marginTop: '-20px'   // ✅ чтобы scroll работал
            }}>
          <table className="results-table" style={{ fontSize: '14px', tableLayout: 'fixed' }}>
              <thead>
                <tr>
                  <th>Округ</th>
                  <th>Регион</th>
                  <th>Ветка</th>
                  <th>Собственник</th>
                  <th>Создал</th>
                  <th>Дата</th>
                  <th>Коммент</th>
                  <th>Координаты</th>
                </tr>
              </thead>
              <tbody>
                {filteredResult.length === 0 ? (
                  <tr>
                    <td colSpan="10" className="no-data">Нет данных для отображения</td>
                  </tr>
                ) : (
                  filteredResult.map((item, index) => (
                    <tr key={index} >
                      <td className="text-shadow-statistics">{item.canton}</td>
                      <td className="text-shadow-statistics">{item.region}</td>
                      <td className="text-shadow-statistics">{item.area}</td>
                      <td className="text-shadow-statistics">{item.ownerPillarName}</td>
                      <td className="text-shadow-statistics">{item.authorId}</td>
                      <td className="text-shadow-statistics">{item.createDate}</td>
                      <td className="text-shadow-statistics"> 
                        {item.description && item.description.match(/.{1,40}/g).map((part, index) => (
                          <span key={index}>
                            {part}
                            <br/>
                          </span>
                        ))}
                      </td>
                      <td className="text-shadow-statistics">
                         <Button 
                            style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                            onClick={(e) => {
                                 e.stopPropagation(); 
                                 copyToClipboard(`${item.latitude}, ${item.longitude}`);
                            }}
                            >
                              <FileCopyIcon style={{ color: '#e0920b' }} />
                          </Button>           

                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
        {/* Snackbar */}
            <Snackbar
              anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
             }}
              open={snackbarOpen}
              autoHideDuration={3000}
              onClose={handleCloseSnackbar}
              message={snackbarMessage}
              ContentProps={{
              style: {
                color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
              }
              }}
            />
    </>
    
  );
};

export default StatisticPillar;